import classNames from "classnames";
import "./Form.css";

import React from "react";

const Form = ({
  children,
  onSubmit,
  id,
  variant,
}: {
  children: React.ReactNode;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  id?: string;
  variant?: "bordered" | "borderless";
}) => {
  const className = classNames("Form", `Form--${variant}`);
  return (
    <form className={className} onSubmit={onSubmit} id={id}>
      {children}
    </form>
  );
};

export default Form;
